// @ts-nocheck
import { Fragment, useRef, useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import Flatpickr from 'react-flatpickr'
import { Calendar, FileX } from 'lucide-react'
import { CubeLoader } from '@/components/ui/cube-loader'
import { GET_SUMMARISATION } from '@/graphql/publisher-dashboard-queries'
import 'flatpickr/dist/flatpickr.css'

const SummarisationReport = () => {
    const { id } = useParams()
    const campaign = useQuery(GET_SUMMARISATION, {
        variables: id ? { where: { id } } : {},
    })
    const fp = useRef(null)
    const [selectedDate, setSelectedDate] = useState(null)
    const [tmDates, setTmDates] = useState([])

    const summaries = () => {
        try {
            return campaign.data.campaigns[0]?.summary
                ? JSON.parse(campaign.data.campaigns[0]?.summary)
                : null
        } catch {
            return campaign.data.campaigns[0]?.summary
        }
    }

    const date = () => {
        const sums = summaries()
        try {
            let date = sums.find((item) => item.date === selectedDate)['date']
            const dateParts = date.split('/')
            date = new Date(`${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`)
            return new Intl.DateTimeFormat('en-AU', { day: '2-digit', month: 'short', year: 'numeric' }).format(date)
        } catch {
            const date = campaign.data.campaigns[0].lastSummarisedAt
            return campaign.data.campaigns[0]?.lastSummarisedAt
                ? new Intl.DateTimeFormat('en-AU', { day: '2-digit', month: 'short', year: 'numeric' }).format(
                      new Date(date),
                  )
                : null
        }
    }

    const text = () => {
        const sums = summaries()
        try {
            return sums.find((item) => item.date === selectedDate)['text']
        } catch {
            return typeof sums === 'string' ? sums : ''
        }
    }

    const handleDateChange = (_selectedDates, dateStr) => {
        const dateParts = dateStr.split('-')
        setSelectedDate(`${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`)
    }

    useEffect(() => {
        if (tmDates.length === 0) {
            let date, dates
            try {
                date = campaign.data.campaigns[0]?.summary
                    ? JSON.parse(campaign.data.campaigns[0]?.summary).pop()['date']
                    : null
                dates = campaign.data.campaigns[0]?.summary
                    ? JSON.parse(campaign.data.campaigns[0]?.summary).map((item) => item.date)
                    : []
            } catch {
                date = null
                dates = []
            }

            if (date) setSelectedDate(date)

            if (dates) {
                setTmDates(
                    dates.map((item) => {
                        const dateParts = item.split('/')
                        return `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`
                    }),
                )
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [campaign, selectedDate])

    return (
        <div className="card">
            {campaign.loading ? (
                <CubeLoader size="sm" />
            ) : (
                <Fragment>
                    <div className="card-header p-4 flex-column pb-1">
                        <div className="d-flex justify-content-between align-items-center gap-2">
                            <h6 className="card-title">Time Machine</h6>
                            {date() && (
                                <div className="d-flex align-items-center gap-1">
                                    <button
                                        type="button"
                                        className="border-0 bg-transparent p-0 d-flex align-items-center text-blue-300"
                                        onClick={() => fp.current?.flatpickr?.open()}
                                        aria-label="Open date picker"
                                    >
                                        <Calendar size={20} />
                                    </button>
                                    <Flatpickr
                                        ref={fp}
                                        options={{ enable: tmDates }}
                                        className="hidden-input"
                                        onChange={handleDateChange}
                                    />
                                    <span className="text-blue-300">{date()}</span>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="card-body card-thumbnail p-4 pt-1">
                        <h6 className="card-title mb-2 small">Generative AI Summarisation</h6>
                        {date() ? (
                            <p className="small mb-0">{text()}</p>
                        ) : (
                            <div className="tw:flex tw:flex-col tw:items-center tw:justify-center tw:py-12 tw:text-gray-400">
                                <FileX size={40} className="tw:mb-3 tw:opacity-30" />
                                <p className="tw:text-sm">No summarisation data available yet.</p>
                            </div>
                        )}
                    </div>
                </Fragment>
            )}
        </div>
    )
}

export default SummarisationReport
